import apiService from './ApiService';

const AsistenteService = {
  /**
   * Obtiene la lista de asistentes del usuario actual
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async getMisAsistentes() {
    try {
      
      const response = await apiService.request('/Asistente/mis-asistentes', {
        method: 'GET'
      });
      
      
      // Validar estructura de respuesta
      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener los asistentes');
      }
      
      // Procesar fechas en los asistentes
      if (response.asistentes && Array.isArray(response.asistentes)) {
        response.asistentes = response.asistentes.map(asistente => ({
          ...asistente,
          fechaAlta: new Date(asistente.fechaAlta)
        }));
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al obtener asistentes:', error);
      throw error;
    }
  },

  /**
   * Elimina un asistente por su ID
   * @param {string} assistantId - ID del asistente aliminar
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async eliminarAsistente(assistantId) {
    try {
      
      const response = await apiService.request(`/Asistente/eliminar/${assistantId}`, {
        method: 'DELETE'
      });
      
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al eliminar el asistente');
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al eliminar asistente:', error);
      throw error;
    }
  },

  async eliminarAsistenteOpenAI(idOpenAIAssistant) {
    try {
      const response = await apiService.request(`/Asistente/${idOpenAIAssistant}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al eliminar el asistente');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al eliminar asistente OpenAI:', error);
      throw error;
    }
  },

  /**
   * Crea un nuevo asistente con archivos PDF
   * @param {FormData} formData - FormData con nombre del asistente y archivos PDF
   * @returns {Promise} Promesa que resuelve con la respuesta de la API
   */
  async crearAsistente(formData) {
    try {
      const response = await apiService.request('/Asistente/crear-openai', {
        method: 'POST',
        body: formData,
        // No establecer Content-Type para FormData, el navegador lo hará automáticamente
        headers: {}
      });
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al crear el asistente');
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error al crear asistente:', error);
      throw error;
    }
  },

  async getAsistenteById(idOpenAIAssistant) {
    try {
      
      const response = await apiService.get(`/Asistente/${idOpenAIAssistant}`);
      
      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener el asistente');
      }
      
      return response;
    } catch (error) {
      console.error('❌ Error al obtener asistente:', error);
      throw error;
    }
  },

  async getAsistentePublicoPorNickname(nickname, regionalNombreUrl, areaId) {
    if (!nickname) {
      throw new Error('No se encontró el nickname del asistente.');
    }
    if (!regionalNombreUrl) {
      throw new Error('No se encontró el regional.');
    }
    if (!areaId) {
      throw new Error('No se encontró el área.');
    }
    const params = new URLSearchParams();
    params.append('asistente', nickname);
    params.append('regional', regionalNombreUrl);
    params.append('areaId', areaId);
    const response = await apiService.getPublic(`/Asistente/publico/por-nickname?${params.toString()}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener el asistente.';
      throw new Error(msg);
    }
    return response;
  },

  async actualizarAsistente(idOpenAIAssistant, formData) {
    try {
      const response = await apiService.request(`/Asistente/openai/${idOpenAIAssistant}`, {
        method: 'PUT',
        body: formData,
        headers: {}
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al actualizar el asistente');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al actualizar asistente:', error);
      throw error;
    }
  }
};

export default AsistenteService;
